const ROOT = 'UNIT_PAYMENT_DETAILS_TABS_INVOICES_';

const actions = {
  LOAD_INVOICES_REQUEST: `${ROOT}LOAD_INVOICES_REQUEST`,
  LOAD_INVOICES_SUCCESS: `${ROOT}LOAD_INVOICES_SUCCESS`,
  LOAD_INVOICES_ERROR: `${ROOT}LOAD_INVOICES_ERROR`,
  CLEAR_STORE: `${ROOT}INVOICES_CLEAR_STORE`,
} as const;

export default actions;
